import jsPDF from 'jspdf';
import 'jspdf-autotable';
// import '../fonts/csv-m-normal';
// import '../fonts/csv-b-bold';


export default function printTableToReport( filenameNew = '', currentScheme = '', layout = '', headerCells = [], bodyRows = [] ){

	let pdf
	let date = new Date();
	let generatedAtStr = `${date.getDate()}.${date.getMonth()+1}.${date.getFullYear()}, ${date.getHours()}:${(date.getMinutes() < 10 ? '0' : '') + date.getMinutes()} Uhr`;
	let isFundliste = ( schemeName )=>{
		const names = [
			'fundliste',
			'Fundliste v2',
			'Fundliste v3',
		]
		
		return names.includes( schemeName )
	}
	let isFotoliste = ( schemeName )=>{
		const names = [
			'fotoliste',
			'Fotoliste v2',
			'Fotoliste v3',
		]
		
		return names.includes( schemeName )
	}
	let useA3forTable = ( schemeName )=>{
		const names = [
			'fundliste',
			'Fundliste v2',
			'Fundliste v3',
			'Fundliste v4',
			'Befundbeschreibung v3',
			'Befundbeschreibung v4',
		]
		
		return names.includes( schemeName )
	}
	let isBefundbeschreibung = ( schemeName )=>{
		const names = [
			'Befundbeschreibung v3',
			'Befundbeschreibung v4',
		]
		
		return names.includes( schemeName )
	}

	console.group('printTableToReport()')
	console.log('         filenameNew:', filenameNew)
	console.log('       currentScheme:', currentScheme)
	console.log('              layout:', layout)
	console.log('               useA3:', useA3forTable(currentScheme) )
	console.log('isBefundbeschreibung:', isBefundbeschreibung(currentScheme) )
	console.log('         headerCells:', headerCells)
	console.log('            bodyRows:', bodyRows)
	console.log('-------------')
	

	if( layout == "asDatasets" ){
		// GET DATA 
		const headElements = headerCells
		const bodyElements = []
		for( let rowIndex = 0; rowIndex < bodyRows.length; rowIndex++ ){
			bodyElements[rowIndex] = []
			
			console.log('     rowIndex:', rowIndex)
			//console.log('-------------')
			
			for( let cellIndex = 0; cellIndex < bodyRows[rowIndex].length; cellIndex++ ){
				const key   = headElements[cellIndex]
				const value = bodyRows[rowIndex][cellIndex]
				
				// needed as otherwise <br> shows up in IE
				//if( cellInnerHTML == '' || cellInnerHTML == '<br>' ) cellInnerHTML = '-'

				bodyElements[rowIndex].push([ key, value ])
			}
		}

		// Create PDF Object
		pdf = new jsPDF("p", "mm", "a4", true);
		pdf.setTextColor('#000000');
		pdf.setDrawColor(0, 0, 0);
		pdf.setLineWidth(0.5);
		pdf.setFontSize(11);
		pdf.setFont("Helvetica")
		/* First Page */
		pdf.setFontSize(16);
		pdf.text("PDF Report für: " + filenameNew, 15, 20);
		pdf.line(15, 22, 200, 22);
		let generatedString = "Generiert am: " + generatedAtStr;
		pdf.setFontSize(11);
		pdf.text(15, 30, generatedString);
		pdf.text("https://denkmalpflege-bw-csv.de/", 15, 35);
		pdf.text("© Landesamt für Denkmalpflege im Regierungspräsidium Stuttgart", 15, 285);

		/* ADD PAGES FROM OBJECT  */
		let i = 0
		for( var item in bodyElements ){
			let c = i + 1
			
			pdf.addPage();
			pdf.setFontSize(16);
			pdf.text("Datenblatt " + c, 15, 20);
			pdf.autoTable({
				//head: [['Name', 'Country']],
				columnStyles: {
					0: {
						halign: 'left',
						minCellWidth: 50,
						fontStyle: 'bold',
						textColor: [0, 0, 0],
						fontSize: 9,
						font: 'Helvetica'
					},
					1: {
						halign: 'left',
						textColor: [0, 0, 0],
						minCellWidth: 135,
						fontSize: 9,
						font: 'Helvetica'
					}
				},
				margin: {
					top: 30
				},
				//pageBreak: 'avoid',
				rowPageBreak: 'avoid',
				body: bodyElements[item],
				theme: 'grid'
			});
			console.log(bodyElements[item])
			i++;
		}

		// Set PDF Properties
		pdf.setProperties({
			title: 'CSV Bericht',
			subject: 'Denkmalpflege Baden-Würtemberg',
			creator: 'https://www.denkmalpflege-bw.de/impressum/'
		});

		// save PDF
		filenameNew = filenameNew + '.datenblaetter.pdf'
		pdf.save(filenameNew)
		//document.getElementsByClassName('img__loading')[0].style.display = 'none'
	} 
	if( layout == "asTable" ){
		// Create PDF Object
		//if( currentScheme == 'fundliste' || currentScheme == 'Fundliste v2' || currentScheme == 'Fundliste v3' ){
		if( useA3forTable( currentScheme ) ){
			pdf = new jsPDF("l", "mm", "a3", true);
		}else{
			pdf = new jsPDF("l", "mm", "a4", true);
		}
		pdf.setTextColor('#000000');
		pdf.setDrawColor(0, 0, 0);
		pdf.setLineWidth(0.5);
		pdf.setFontSize(10);
		pdf.setFont("Helvetica")
		// First Page
		pdf.setFontSize(16);
		pdf.text("PDF Report für: " + filenameNew, 15, 20);
		pdf.line(15, 22, 280, 22);
		pdf.setFontSize(10);
		let generatedString = "Generiert am: " + generatedAtStr;
		pdf.text(15, 30, generatedString);
		pdf.text("https://denkmalpflege-bw-csv.de/", 15, 35);
		if( useA3forTable(currentScheme) ){
			let generatedString = "Aufgrund der Tabellenbreite wurde das PDF im A3-Format erzeugt. Für Druck auf A4 stellen Sie bitte in Ihrem Drucker 'Skalieren: auf Seite anpassen' ein.";
			pdf.text(15, 50, generatedString);
		}
		pdf.text("© Landesamt für Denkmalpflege im Regierungspräsidium Stuttgart", 15, 285);
		pdf.addPage();
		pdf.setFontSize(7);

		// Adjust Cell size for different landscape formats
		var colStyles
		if( isFundliste(currentScheme) ){
			colStyles = {
				0: {
					cellWidth: 10,
				},
				5: {
					cellWidth: 30
				},
				6: {
					cellWidth: 30
				},
				7: {
					cellWidth: 10
				},
				8: {
					cellWidth: 5
				},
				10: {
					cellWidth: 70
				},
				11: {
					cellWidth: 5
				},
				13: {
					cellWidth: 23
				},
				14: {
					cellWidth: 30
				}
			}
		}else if( isFotoliste(currentScheme) ){
			colStyles = {
				6: {
					cellWidth: 90,
				},
				7: {
					cellWidth: 30,
				},
				8: {
					cellWidth: 40,
				}
			}
		}else if( isBefundbeschreibung(currentScheme)){
			// hier müssten die angepassten breiten für das schema hin
		}else{
			// probenliste
			colStyles = {
				5: {
					cellWidth: 40
				},
				6: {
					cellWidth: 70
				},
			}
		}

		pdf.autoTable({
			//html: '.csv-table',
			head: [ headerCells ],
			body: bodyRows,
			margin: 6,
			columnStyles: colStyles,
			cellPadding: 3,
			theme: 'grid',
			didParseCell: function(table) {

				if (table.section === 'head') {
					table.cell.styles.fillColor = '#ccc';
					table.cell.styles.textColor = '#000';
					table.cell.styles.fontSize = 9;
					table.cell.styles.overflow = 'ellipsize';
				}

				// hier müssten die anpassungen für isBefundbeschreibung() hin
				if (table.section === 'head' && isBefundbeschreibung(currentScheme)) {
					table.cell.styles.fontSize = 8.5;
				}
				
				// replace some headings
				if (table.section === 'head' && currentScheme == 'fundliste') {
					table.cell.styles.fontSize = 8.5;
				}
				if (table.section === 'head' && table.cell.text == 'in Restaurierung') {
					table.cell.text = 'in Restau.';
				}
				if (table.section === 'head' && table.cell.text == 'Warenart/Bezeichnung/Objekttyp') {
					table.cell.text = 'Warena./Bez./Objekttyp';
				}
				if (table.section === 'head' && table.cell.text == 'Warenart/Bezeichnung/Objekttyp') {
					table.cell.text = 'Warena./Bez./Objekttyp';
				}
				if (table.section === 'head' && table.cell.text == 'Anzahl') {
					table.cell.text = 'Anz.';
				}
				if (table.section === 'body') {
					table.cell.styles.fontSize = 9;
					table.cell.styles.font = 'courier';
					table.cell.cellPadding = 3;
				}

			},
		});

		// Set PDF Properties
		pdf.setProperties({
			title: 'CSV Bericht',
			subject: 'Denkmalpflege Baden-Würtemberg',
			creator: 'https://www.denkmalpflege-bw.de/impressum/'
		});

		// save PDF
		filenameNew = filenameNew + '.tabelle.pdf'
		pdf.save(filenameNew);
		//document.getElementsByClassName('img__loading')[0].style.display = 'none'
	}

	console.groupEnd()
	
}
